import React from "react";
import { Users, Eye, Wrench, Handshake, MapPin, Map } from 'lucide-react'; // Yeni ikon kütüphanesi

const AboutPage = () => {
  return (
    <div className="bg-gradient-to-br from-gray-900 to-gray-800 min-h-screen text-gray-50 font-sans">
      <main className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* === Sayfa Başlığı === */}
        <header className="text-center mb-12">
          <h1 className="text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-400 to-indigo-500 tracking-tight">
            Hakkımızda
          </h1>
          <p className="mt-4 text-lg text-gray-300 max-w-2xl mx-auto">
            Mekânname'nin hikayesini ve misyonunu keşfedin.
          </p>
        </header>

        {/* === Ana İçerik === */}
        <div className="space-y-12">
          {/* === Biz Kimiz? === */}
          <section className="bg-gray-800 p-8 rounded-3xl shadow-xl border border-gray-700">
            <div className="flex items-center gap-4 mb-4">
              <Users className="h-8 w-8 text-blue-400" />
              <h2 className="text-3xl font-bold text-gray-50">Biz Kimiz?</h2>
            </div>
            <p className="text-gray-300 leading-relaxed text-lg">
              Mekânname olarak, geçmişin izlerini dijital çağa taşıyan yenilikçi bir platformuz. Türkiye'nin ve dünyanın dört bir yanındaki tarihi mekânları keşfetmeyi, bu zenginlikleri belgelemeyi ve gelecek nesillere aktarmayı misyon edindik. Teknoloji ve tarihin kesişim noktasında, kültürel mirasımızı herkes için erişilebilir kılmak için tutkuyla çalışıyoruz. Tarihi yeniden canlandırmak ve öğrenmeyi keyifli hale getirmek için buradayız.
            </p>
          </section>

          {/* === Vizyonumuz === */}
          <section className="bg-gray-800 p-8 rounded-3xl shadow-xl border border-gray-700">
            <div className="flex items-center gap-4 mb-4">
              <Eye className="h-8 w-8 text-blue-400" />
              <h2 className="text-3xl font-bold text-gray-50">Vizyonumuz</h2>
            </div>
            <p className="text-gray-300 leading-relaxed text-lg">
              Vizyonumuz, her bir kullanıcının kendi "tarih avcısı" olabileceği, keşfettiği mekânlarla ilgili bilgileri paylaşabileceği ve yapay zeka destekli açıklamalarla geçmişi yeniden deneyimleyebileceği küresel bir topluluk oluşturmaktır. Mekânname, sadece bir uygulama değil; aynı zamanda tarihe duyulan saygının, öğrenme arzusunun ve keşfetme heyecanının buluştuğu eşsiz bir platformdur. Amacımız, Anadolu’nun binlerce yıllık mirasını dijital çağın ışığında geleceğe taşımak; Mekânname’yi sadece Türkiye’nin değil, dünyanın kültür turizmi alanında referans gösterdiği milli bir marka haline getirmek.
            </p>
          </section>

          {/* === Neler Sunuyoruz? === */}
          <section className="bg-gray-800 p-8 rounded-3xl shadow-xl border border-gray-700">
            <div className="flex items-center gap-4 mb-6">
              <Wrench className="h-8 w-8 text-blue-400" />
              <h2 className="text-3xl font-bold text-gray-50">Neler Sunuyoruz?</h2>
            </div>
            <ul className="grid md:grid-cols-2 gap-8 text-lg">
              <li className="flex gap-4">
                <Map className="h-6 w-6 text-blue-400 shrink-0 mt-1" />
                <div>
                  <strong className="text-gray-50">Yapay Zeka Destekli Mekân Tanıma:</strong>
                  <span className="text-gray-300 block mt-1">Yüklediğiniz fotoğraflar aracılığıyla tarihi yapıları anında tanımlar, size detaylı ve doğru bilgiler sunarız.</span>
                </div>
              </li>
              <li className="flex gap-4">
                <MapPin className="h-6 w-6 text-blue-400 shrink-0 mt-1" />
                <div>
                  <strong className="text-gray-50">Kapsamlı Tarihi Bilgiler:</strong>
                  <span className="text-gray-300 block mt-1">Tanınan mekânların tarihi, mimarisi, kültürel önemi ve ilginç hikayeleri hakkında güvenilir ve zengin içerikler sağlarız.</span>
                </div>
              </li>
              <li className="flex gap-4">
                <Handshake className="h-6 w-6 text-blue-400 shrink-0 mt-1" />
                <div>
                  <strong className="text-gray-50">Kullanıcı Katkıları ve Topluluk:</strong>
                  <span className="text-gray-300 block mt-1">Kullanıcılarımızın kendi keşiflerini, fotoğraflarını ve hikayelerini paylaşarak platformumuzu zenginleştirmesini ve büyüyen bir tarih topluluğunun parçası olmasını teşvik ederiz.</span>
                </div>
              </li>
              <li className="flex gap-4">
                <Map className="h-6 w-6 text-blue-400 shrink-0 mt-1" />
                <div>
                  <strong className="text-gray-50">Özel Rota Oluşturma ve Takip:</strong>
                  <span className="text-gray-300 block mt-1">Kendi tarihi gezi rotalarınızı oluşturun, favori mekânlarınızı bir araya getirin ve ziyaretlerinizi kolayca takip edin.</span>
                </div>
              </li>
              <li className="flex gap-4">
                <Map className="h-6 w-6 text-blue-400 shrink-0 mt-1" />
                <div>
                  <strong className="text-gray-50">Sanal Turlar:</strong>
                  <span className="text-gray-300 block mt-1">Kendi tarihi gezi rotalarınızı oluşturun, favori mekânlarınızı bir araya getirin ve ziyaretlerinizi kolayca takip edin.</span>
                </div>
              </li>
              <li className="flex gap-4">
                <Map className="h-6 w-6 text-blue-400 shrink-0 mt-1" />
                <div>
                  <strong className="text-gray-50">Mekanname Quiz:</strong>
                  <span className="text-gray-300 block mt-1">Kendi tarihi gezi rotalarınızı oluşturun, favori mekânlarınızı bir araya getirin ve ziyaretlerinizi kolayca takip edin.</span>
                </div>
              </li>
            </ul>
          </section>

          {/* === Bize Ulaşın === */}
          <section className="bg-gray-800 p-8 rounded-3xl shadow-xl border border-gray-700">
            <div className="flex items-center gap-4 mb-4">
              <Users className="h-8 w-8 text-blue-400" />
              <h2 className="text-3xl font-bold text-gray-50">Bize Ulaşın</h2>
            </div>
            <p className="text-gray-300 leading-relaxed text-lg">
              Her türlü soru, öneri, geri bildirim ve işbirliği talepleriniz için bize ulaşmaktan çekinmeyin. Ekibimiz size en kısa sürede yardımcı olmaktan mutluluk duyacaktır.
              <br /><br />
              <strong className="text-gray-50">E-posta:</strong>{" "}
              <a href="mailto:info@mekanname.com" className="text-blue-400 hover:underline transition-colors">info@mekanname.com</a>
              <br />
              <strong className="text-gray-50">Sosyal Medya:</strong>{" "}
              <a href="https://twitter.com/mekanname" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline transition-colors">Twitter</a> |{" "}
              <a href="https://instagram.com/mekanname" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline transition-colors">Instagram</a> |{" "}
              <a href="https://facebook.com/mekanname" target="_blank" rel="noopener noreferrer" className="text-blue-400 hover:underline transition-colors">Facebook</a>
            </p>
          </section>
        </div>
      </main>

      {/* === Footer === */}
      <footer className="text-center py-2 text-gray-400 text-sm  border-gray-700 mt-12">
      </footer>
    </div>
  );
};

export default AboutPage;